// @flow
import React, { Component } from 'react';

import style from './VerificationBanner.scss';


type Props = {
};

type State = {
  show: boolean;
};

export default class VerificationBanner extends Component<Props, State> {
  timerId: TimeoutID;

  state: State = {
    show: true,
  }

  handleClick = () => {
    this.setState({show: false});
  };
  
  componentDidMount() {
    this.timerId = setTimeout(() => this.setState({show: false}), 8000);
  };

  componentWillUnmount() {
    clearTimeout(this.timerId);
  }

  render() {
    const  { show }  = this.state;

    return (
      <div className={style.containerWrap}>
        {show && (<div className={style.contentWrap}>
          <div className={style.textWrap}>
            <span>Verifica que la información del producto sea igual a la tienda antes de realizar el pedido.</span>
          </div>
          <div className={style.buttonWrap}>
            <button className={style.closeButton} onClick={this.handleClick}>X</button>
          </div>
        </div>)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/VerificationBanner/VerificationBanner.jsx